(function(){
    angular
        .module('appback')
        .filter('categoriapiz', categoriapiz);

        categoriapiz.$inject = ['$sce'];
        function categoriapiz($sce){
            return function (item,categoriassel,user_id) {
            	//return item;
            	//console.log("item",item);
            	//console.log("categoriasSel",categoriassel);
            	//console.log("user_id",user_id);
            	var cat_ids = [];
            	Object.keys(categoriassel).forEach(key => {
            		if(key=='all' && categoriassel[key]==1){
	            		//cat_ids.push(""+key);
            			//return true;
            		}else{
            			if(categoriassel[key])
	            			cat_ids.push(""+key);
	            	}
				    //console.log(key, categoriassel[key]);
				});

				var out = [];
			    for (var i = 0; i < item.length; i++){
			      	if(cat_ids.length==0 || cat_ids.indexOf(""+item[i].categoriapizarra_id) !== -1 || item[i].user_id==user_id){
			      		out.push(item[i]);
					}
			    }      
			    return out;
				
	        };
      }
})();